import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV_SECTIONS = [
    {
        title: 'Overview',
        items: [
            { path: '/admin/overview', label: 'Dashboard' },
            { path: '/admin/growth', label: 'Growth' },
            { path: '/admin/retention', label: 'Retention' },
            { path: '/admin/revenue', label: 'Revenue' },
            { path: '/admin/baseline', label: 'Release Baseline' },
        ]
    },
    {
        title: 'Content',
        items: [
            { path: '/admin/content', label: 'Manifest curation' },
            { path: '/admin/feedback', label: 'Feedback inbox' },
        ]
    },
    {
        title: 'Compatibility',
        items: [
            { path: '/admin/compat/matrix', label: 'Compat Matrix' },
            { path: '/admin/compat/errors', label: 'Error Leaderboard' },
            { path: '/admin/compat/sinks', label: 'Sink Registry' },
            { path: '/admin/compat/oui', label: 'OUI Analysis' },
            { path: '/admin/compat/unknown-oui', label: 'Unknown OUIs' },
            { path: '/admin/compat/devices', label: 'Device Database' },
        ]
    },
    {
        title: 'Infrastructure',
        items: [
            { path: '/admin/pipeline', label: 'Pipeline Health' },
            { path: '/admin/alerts', label: 'Alerts' },
            { path: '/admin/features', label: 'Feature Adoption' },
            { path: '/admin/geo', label: 'Geography' },
            { path: '/admin/db-console', label: 'DB Console' },
            { path: '/admin/pipeline-analytics', label: 'Pipeline Analytics' },
            { path: '/admin/live-events', label: 'Live Events' },
            { path: '/admin/connection-funnel', label: 'Connection Funnel' },
            { path: '/admin/source-protocol-matrix', label: 'Source × Protocol Matrix' },
        ]
    },
    {
        title: 'Legacy',
        items: [
            { path: '/admin/casting', label: 'Casting Analytics' },
            { path: '/admin/visitors', label: 'Site Visitors' },
        ]
    },
];

export default function AdminLayout() {
    const { user, logout } = useAuth();

    return (
        <div className="min-h-screen flex bg-gray-50">
            {/* Sidebar */}
            <aside className="w-64 bg-white shadow-md flex flex-col">
                <div className="p-4 border-b">
                    <h1 className="text-xl font-bold text-zebcast-purple">ZebCast Admin</h1>
                    <p className="text-xs text-gray-500 mt-1">{user?.email}</p>
                </div>
                <nav className="flex-1 overflow-y-auto p-2">
                    {NAV_SECTIONS.map((section) => (
                        <div key={section.title} className="mb-4">
                            <p className="px-3 py-1 text-xs font-semibold text-gray-400 uppercase tracking-wider">
                                {section.title}
                            </p>
                            {section.items.map((item) => (
                                <NavLink
                                    key={item.path}
                                    to={item.path}
                                    className={({ isActive }) =>
                                        `block px-3 py-2 rounded-md text-sm transition-colors ${
                                            isActive
                                                ? 'bg-zebcast-purple text-white'
                                                : 'text-gray-700 hover:bg-gray-100'
                                        }`
                                    }
                                >
                                    {item.label}
                                </NavLink>
                            ))}
                        </div>
                    ))}
                </nav>
                <div className="p-4 border-t">
                    <button onClick={logout}
                        className="w-full px-4 py-2 text-sm bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors">
                        Logout
                    </button>
                </div>
            </aside>

            {/* Content */}
            <main className="flex-1 p-8 overflow-y-auto">
                <Outlet />
            </main>
        </div>
    );
}
